export const DPIA_CRITERIA_VERSION = 'imy_edpb_v1';

/** Screening codes from GET dpia-screening-criteria (imy_edpb_v1). Sent as-is on save/decide. */
export const DPIA_SCREENING_CRITERION_CODES = [
  'systematic_evaluation_or_profiling',
  'automated_significant_decisions',
  'systematic_monitoring',
  'sensitive_or_highly_personal_data',
  'large_scale_processing',
  'matching_or_combining_datasets',
  'vulnerable_data_subjects',
  'innovative_technology_or_use',
  'prevents_rights_services_or_contracts',
  'other_high_risk_criterion',
] as const;

export const DPIA_TRIGGER_SOURCE_OPTIONS = [
  'asset_owner_indication',
  'ropa_administrator',
  'formal_ropa_review',
  'project_or_change',
  'periodic_reassessment',
  'other',
] as const;
